export default __webpack_public_path__ + "static/media/instagram-white.5be36f16.svg";